"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_1 = __importDefault(require("../base"));

var auth_1 = __importDefault(require("./auth"));

var batch_jobs_1 = __importDefault(require("./batch-jobs"));

var collections_1 = __importDefault(require("./collections"));

var customer_groups_1 = __importDefault(require("./customer-groups"));

var customers_1 = __importDefault(require("./customers"));

var discounts_1 = __importDefault(require("./discounts"));

var draft_orders_1 = __importDefault(require("./draft-orders"));

var gift_cards_1 = __importDefault(require("./gift-cards"));

var invites_1 = __importDefault(require("./invites"));

var notes_1 = __importDefault(require("./notes"));

var notifications_1 = __importDefault(require("./notifications"));

var orders_1 = __importDefault(require("./orders"));

var price_lists_1 = __importDefault(require("./price-lists"));

var product_tags_1 = __importDefault(require("./product-tags"));

var product_types_1 = __importDefault(require("./product-types"));

var products_1 = __importDefault(require("./products"));

var regions_1 = __importDefault(require("./regions"));

var return_reasons_1 = __importDefault(require("./return-reasons"));

var returns_1 = __importDefault(require("./returns"));

var shipping_options_1 = __importDefault(require("./shipping-options"));

var shipping_profiles_1 = __importDefault(require("./shipping-profiles"));

var store_1 = __importDefault(require("./store"));

var swaps_1 = __importDefault(require("./swaps"));

var tax_rates_1 = __importDefault(require("./tax-rates"));

var uploads_1 = __importDefault(require("./uploads"));

var users_1 = __importDefault(require("./users"));

var variants_1 = __importDefault(require("./variants"));

var Admin =
/** @class */
function (_super) {
  __extends(Admin, _super);

  function Admin() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.auth = new auth_1.default(_this.client);
    _this.batchJobs = new batch_jobs_1.default(_this.client);
    _this.customers = new customers_1.default(_this.client);
    _this.customerGroups = new customer_groups_1.default(_this.client);
    _this.discounts = new discounts_1.default(_this.client);
    _this.collections = new collections_1.default(_this.client);
    _this.draftOrders = new draft_orders_1.default(_this.client);
    _this.giftCards = new gift_cards_1.default(_this.client);
    _this.invites = new invites_1.default(_this.client);
    _this.notes = new notes_1.default(_this.client);
    _this.priceLists = new price_lists_1.default(_this.client);
    _this.products = new products_1.default(_this.client);
    _this.productTags = new product_tags_1.default(_this.client);
    _this.productTypes = new product_types_1.default(_this.client);
    _this.users = new users_1.default(_this.client);
    _this.returns = new returns_1.default(_this.client);
    _this.orders = new orders_1.default(_this.client);
    _this.returnReasons = new return_reasons_1.default(_this.client);
    _this.variants = new variants_1.default(_this.client);
    _this.swaps = new swaps_1.default(_this.client);
    _this.shippingProfiles = new shipping_profiles_1.default(_this.client);
    _this.store = new store_1.default(_this.client);
    _this.shippingOptions = new shipping_options_1.default(_this.client);
    _this.regions = new regions_1.default(_this.client);
    _this.notifications = new notifications_1.default(_this.client);
    _this.taxRates = new tax_rates_1.default(_this.client);
    _this.uploads = new uploads_1.default(_this.client);
    return _this;
  }

  return Admin;
}(base_1.default);

exports.default = Admin;